<div *ngIf="drawerOpen" [@drawerTrigger] class="drawer">
  <div class="drawer-content">
    <ng-container #drawerContent></ng-container>
  </div>
</div>
